import AudioNode from "./audionode";
import CanvasNode from "./canvasnode";
import ImageNode from "./imagenode";
import MediaNode from "./medianode";
import SourceNode from "./sourcenode";
import VideoNode from "./videonode";

const NODES = {
    AudioNode,
    CanvasNode,
    ImageNode,
    MediaNode,
    SourceNode,
    VideoNode
};

export default NODES;
